export interface ChartData {
  name: string;
  value?: number;
  series?: Array<{ name: string; value: number | string }>;
}

export enum Icons {
  asc = "fa fa-sort-asc",
  desc = "fa fa-sort-desc",
  none = "fa fa-sort"
}

export enum KNETStatusEnum {
  UNKNOWN = 0,
  INITIATED = 1,
  SUCCESS = 2,
  FAILED = 3,
  CANCELLED = 4,
  CONFLICT = 5,
  REFUNDED = 6,
  NOTFOUND = 7,
  ABANDONED = 8,
  VOID = 9
}

export var SubscriptionTypes = [
  { id: 1, value: "Parking" },
  { id: 2, value: "Company" }
];
export var ParkingStatus = [  //checked_in, parked, requested, valet-assigned, on-the-way, checkout, delivered
  { id: 1, value: "checked_in" },
  { id: 2, value: "parked" },
  { id: 3, value: "requested" },
  { id: 4, value: "valet-assigned" },
  { id: 5, value: "on-the-way" },
  { id: 6, value: "checkout" },
  { id: 7, value: "delivered" },
];


export enum SubscribedTypes {
  FALSE = 1,
  TRUE = 2
};

export enum UserGroups {
  MANAGER = "manager",
  ADMIN = "admin",
  SUPERVISOR = "supervisor",
  CUSTOMER = "customer",
  SUPPORTUSER = "SupportUser",
  FINANCE = "finance",
  CORPORATE = "corporate",
  CHANNELPARTNER = "channel_partner",
  PRIVATEMANAGER = "private_parking_manager"
}

export enum CorporateAccountType {
  CORPORATE = 1,
  CHANNELPARTNER = 2
}

export enum IconCss {
  left = "fa fa-chevron-left",
  right = "fa fa-chevron-right",
  previous = "fa fa-angle-double-left",
  next = "fa fa-angle-double-right"
}

export enum TreeMap {
  LIVE_PASS = 1,
  LIVE_MANUAL = 2,
  CLOSED_PASS = 3,
  CLOSED_MANUAL = 4,
  ALL = 5,
  CLOSED_SUBSCRIBER=6,
  LIVE_GUEST=7,
  LIVE_SUBSCRIBER=8,
  CLOSED_GUEST=9,
  LIVE_COMPANY =10,
  CLOSED_COMPANY =11
}

export enum UserSearchModalEvents {
  INVITE = 0,
  USER = 1
}

export var gender = [
  { id: 0, value: "male", name: "male" },
  { id: 1, value: "female", name: "female" }
];

export var ticketTypes = [
  { id: 0, value: "open", name: "Open" },
  { id: 1, value: "closed", name: "Closed" }
];


export var KNETStatus = [
  { id: KNETStatusEnum.UNKNOWN, name: "Unknown" },
  { id: KNETStatusEnum.INITIATED, name: "Initiated" },
  { id: KNETStatusEnum.SUCCESS, name: "Success" },
  { id: KNETStatusEnum.FAILED, name: "Failed" },
  { id: KNETStatusEnum.CANCELLED, name: "Cancelled" },
  { id: KNETStatusEnum.CONFLICT, name: "Conflict" },
  { id: KNETStatusEnum.REFUNDED, name: "Refunded" },
  { id: KNETStatusEnum.NOTFOUND, name: "Not Found" },
  { id: KNETStatusEnum.ABANDONED, name: "Abandoned" },
  { id: KNETStatusEnum.VOID, name: "Void" }
];

export var SettlementStatus = [
  { id: 1, name: "INITIATED" },
  { id: 2, name: "SETTLED" }
];

export var payModes = [
  { id: 1, name: "KNET" },
  { id: 2, name: "Cash" },
  { id: 3, name: "Cheque Payment" },
  { id: 5, name: "PayPal" }
];

export var CommissionTypes = [
  { id: 1, name: "Fixed" },
  { id: 2, name: "Percentage" }
];

export interface User {
  //$key: string;
  account: string;
  deviceID: string;
  email: string;
  id: Number;
  mobile: string
  name: Number;
  reference: string;
  served: boolean;
  timestamp: string;
}

export interface CouponResponse{
  code:string;
}

export enum TicketType{
  Public = 1,
  Private = 2,
  PreBooking = 3
}
